import { ref, reactive } from 'vue';
import axios from 'axios';

const useRequest = initialData => {
        const loading = ref(false);
        const error = ref(undefined);
        const errors = ref();

        const baseOptions = {
                baseURL: process.env.STOCK_SPREADSHEET_MAPPING_DASHBOARD_API_BASE_URL + 'api',
                headers: {
                        Accept: 'application/json',
                        'Content-Type': 'application/json; charset=utf-8',
                        'X-Requested-With': 'XMLHttpRequest',
                        Authorization: `Bearer ${localStorage.getItem('greeners_auth_token')}`
                },
                withCredentials: true
        };

        const instance = axios.create(baseOptions);

        const data = reactive(initialData);

        instance.interceptors.response.use(
                response => {
                        loading.value = false;

                        if (response.data && response.data.errors) {
                                errors.value = response.data.errors;
                        }

                        return response;
                },
                axiosError => {
                        loading.value = false;

                        handleError(axiosError);

                        return Promise.reject(axiosError);
                }
        );

        const formDataConfig = {
                headers: {
                        'Content-Type': 'multipart/form-data'
                },
                withCredentials: true
        };

        const handleError = axiosError => {
                if (axiosError.response?.data?.message) {
                        error.value = axiosError.response.data.message;
                }

                if (axiosError && axiosError.response.data && axiosError.response.data.errors) {
                        errors.value = axiosError.response.data.errors;
                }
        };

        const execute = async (method = 'get', url, onSuccess) => {
                //@todo dev return for wla

                return;
                try {
                        loading.value = true;

                        const isFormData = Object.values(data).some(
                                value => value instanceof File
                        );

                        const response = isFormData
                                ? // @ts-ignore
                                await instance[method](url, createFormData(data), formDataConfig)
                                : // @ts-ignore
                                await instance[method](
                                        url,
                                        method.toLowerCase() === 'get' ? { params: data } : data
                                );

                        if (onSuccess) {
                                if (response.data.data) {
                                        onSuccess(response.data.data);
                                } else {
                                        onSuccess(response.data);
                                }
                        }
                } catch (error) {
                        handleError(error);
                } finally {
                        loading.value = false;
                }
        };

        const createFormData = data => {
                const formData = new FormData();

                for (const key in data) {
                        formData.append(key, data[key]);
                }

                return formData;
        };

        return {
                loading,
                error,
                errors,
                execute,
                data
        };
};

export default useRequest;
